import { render } from "./AnalyticsCorrectnessMode.vue?vue&type=template&id=55036d76&scoped=true"
import script from "./AnalyticsCorrectnessMode.vue?vue&type=script&lang=js"
export * from "./AnalyticsCorrectnessMode.vue?vue&type=script&lang=js"

import "@/css/components/analytics-correctness-mode.css?vue&type=style&index=0&id=55036d76&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55036d76"]])

export default __exports__